export const storageConstants = {
  ROLES: {
    ALL: ["SuperAdmin", "Admin", "Manager", "Guest"],
    SUPER_ADMIN: "SuperAdmin",
    ADMIN: "Admin",
    MANAGER: "Manager",
    GUEST: "Guest",
  },

  PAGES: {
    TITLE: {
      ONENESS: "Oneness",
    },
    MENU: {
      DASHBOARD: "Dashboard",
      PROFILE: "Profile",
      USER_MANAGEMENT: "User Management",
      EMOTION_MANAGEMENT: "Emotion Management",
      ACTIVITY_MANAGEMENT: "Activity Management",
      ALARM_MANAGEMENT: "Alarm Quote/Music",
      CATEGORIES_MANAGEMENT: "Categories Management",
      QUOTE_MANAGEMENT: "Quote Management",
      SUBSCRIPTION: "Subscription",
      NOTIFICATION: "Notification",
      REMEMBER_ACTIVITY: "Remember Activity",
      MANAGE_CONNECTION: "Manage Connection",
      ACCOUNTS: "Accounts",
      SETTINGS: "Settings",
      TRAIL_CONFIGURATION: "Trail Configuration",
      TRANSACTIONS: "Transactions",
    },
    ROUTE: {
      LOGIN: "/login",
      DASHBOARD: "/",
      PROFILE: "/profile",
      USER_MANAGEMENT: "/user-management",
      EMOTION_MANAGEMENT: "/emotion-management",
      ACTIVITY_MANAGEMENT: "/activity-management",
      VIEW_ACTIVITY_MANAGEMENT: "/activity-management/view",
      CREATE_ACTIVITY_MANAGEMENT: "/activity-management/create",
      ALARM_MANAGEMENT: "/alarm-management",
      CATEGORIES_MANAGEMENT: "/categories-management",
      QUOTE_MANAGEMENT: "/quote-management",
      SUBSCRIPTION: "/subscription",
      TRANSACTIONS: "/transactions",
      TRAIL_CONFIGURATION: "/trail-configuration",
      ACCOUNTS: "/accounts",

      NOTIFICATIONS: "/notifications",
      SETTINGS: "/setting",
      VIEW_NOTIFICATION: "/notifications/view",
      CREATE_NOTIFICATION: "/notifications/create",
      REMEMBER_ACTIVITY: "/remember-activity",
      MANAGE_CONNECTION: "/manage-connection",
    },
    PROFILE: {
      TITLE: "Profile",
    },
    ACCOUNTS: {
      TITLE: "Accounts",
    },
    USER_MANAGEMENT: {
      TITLE: "User Management",
      REQUEST_VERIFICATION: {
        TITLE: "Request Verification",
      },
    },
    EMOTION_TYPE_OPTIONS: [
      { value: "negative", label: "Negative" },
      { value: "positive", label: "Positive" },
    ],
    REQUEST_VERIFICATION_OPTIONS: [
      { value: "All", label: "All" },
      { value: "Approved", label: "Approved" },
      { value: "Rejected", label: "Rejected" },
      { value: "Submitted", label: "Submitted" },
    ],
    USER_MANAGEMENT_OPTIONS: [
      { value: "all", label: "All" },
      { value: "activated", label: "Activated" },
      { value: "deactivated", label: "Deactivated" },
      { value: "deleted", label: "Deleted" },
    ],
    ACTIVE_STATUS: [
      { value: true, label: "Active" },
      { value: false, label: "Inactive" },
    ],
    YESNO_STATUS: [
      { value: true, label: "Yes" },
      { value: false, label: "No" },
    ],
    SUBSCRIPTION_TYPE: [
      { value: "weekly", label: "Weekly" },
      { value: "monthly", label: "Monthly" },
      { value: "annually", label: "Annually" },
    ],
    ALARM_TYPE: [
      { value: "music", label: "Music" },
      { value: "quote", label: "Quote" },
    ],
    QUOTE_TYPE: [
      { value: "weekly", label: "Weekly" },
      { value: "daily", label: "Daily" },
    ],
    ACTIVITY_TYPE: [
      { value: "text", label: "Text" },
      { value: "image", label: "Image" },
      { value: "video", label: "Video" },
    ],
    LOGOUT: {
      TITLE: "Logout",
    },
  },
  SORT_DIRECTION: ["descend", "ascend"],
  FALLBACK:
    "data:image/png;base64,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",
};
